// utils/runtime.ts
export const isMobileWrapper = (): boolean => {
  // The comment above explains *why* we check these globals.
  return !!(window as any).Capacitor || !!(window as any).cordova;
};